import { Children, isValidElement } from 'react';

/**
 * Gets only a count of the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 * @see Dropdown
 */
export default function getValidChildrenCount(children: React.ReactNode) {
  let count = 0;

  Children.forEach(children, (child) => {
    if (isValidElement(child)) {
      count++;
    }
  });

  return count;
}
